<template>
  <div class="modal fade" :ref="`modal-send-email-and-notification`">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">{{ $t(modalTitle) }}
            {{ sendInvoiceType === sendInvoiceTypeEnum.PERIODIC ? $t('invoice.sendInvoiceType.PERIODIC') : $t('invoice.sendInvoiceType.REMINDER') }}</h4>
        </div>
        <div class="modal-body">
          <div class="row label_choose_print">
            <!-- BEGIN - Print Pdf With choosing -->
            <div class="form-group">
              <label
                for="name"
                class="col-md-3 col-sm-3 control-label"
                style="margin-top:13px;"
                ></label
              >
              <div class="col-md-6 col-sm-6">
                <div class="radio">
                  <label>
                    <input
                      type="radio"
                      name="sendEmailAndNotificationInvoice"
                      id="optionsRadiosInvoice1"
                      :value="true"
                      v-model="isSelectMonth"
                    />
                    {{ $t("invoice.by_month") }}
                  </label>
                  <label style="margin-left:30px;"></label>
                  <label>
                    <input
                      type="radio"
                      name="sendEmailAndNotificationInvoice"
                      id="optionsRadiosInvoice2"
                      :value="false"
                      v-model="isSelectMonth"
                    />
                    {{
                      $t("invoice.modal_create_liabilities.label_by_selected")
                    }}
                  </label>
                </div>
              </div>
              <!-- /.input group -->
            </div>
          </div>
          <br/>
          <div class="row mt-2 mb-1 margin-down-15" v-if="isSelectMonth">
            <div class="form-group">
              <label for="name" class="col-md-3 col-sm-3 control-label">{{
                $t("invoice.month")
              }}</label>

              <div class="col-md-6 col-sm-6">
                <date-picker
                  v-model="datePickerValue"
                  @dp-change="onHandleChangeMonth(datePickerValue)"
                  :config="optionsPicker"
                ></date-picker>
              </div>
            </div>
          </div>

          <br />

          <div class="row mt-2 mb-1 margin-down-15" v-if="sendInvoiceType===sendInvoiceTypeEnum.REMINDER">
            <div class="form-group">
              <label for="name" class="col-md-3 col-sm-3 control-label">{{
                $t("Hạn thanh toán")
              }}</label>

              <div class="col-md-6 col-sm-6">
                <date-picker
                  v-model="reminderDatePickerValue"
                  :config="optionsPickerRemider"
                ></date-picker>
              </div>
            </div>
          </div>

          <br />

          <!-- END - Month From -->
        </div>
        <div class="modal-footer">
          <button
            style="background-color: #f29911;border-color: #f29911;color:#fff"
            type="button"
            class="btn btn-default pull-left"
            data-dismiss="modal"
          >
            {{ $t("common.back") }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="onSendNotification"
          >
            {{ $t(modalTitle) }}
          </button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import LTECoreAlert from "@/components/LTESnackBar.vue";
import datePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import moment from "moment";
import utils from "@/lib/utils";
import Enum from "../../../enum/enum"
import Loading from "vue-loading-overlay";

export default {
  components: {
    "lte-core-alert": LTECoreAlert,
    "date-picker": datePicker,
    loading: Loading
  },
  props: {
    periodDataList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      modalTitle: '',
      isSelectMonth: true,
      periodSelect: null,
      periodDisabledList: true,
      SquareChecked: 1,
      datePickerValue: null,
      reminderDatePickerValue: moment(new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate() + 5
      )).format("DD/MM/YYYY"),
      optionsPicker: {
        useCurrent: false,
        minDate: new Date(2019, 0),
        // maxDate: moment().format("YYYY/MM"),
        format: "YYYY/MM",
        locale: this.$i18n.locale == "en" ? "en" : "vi"
      },
      optionsPickerRemider: {
        useCurrent: false,
        minDate: new Date(),
        format: "DD/MM/YYYY",
        locale: this.$i18n.locale == "en" ? "en" : "vi",
      },
      invoiceArrayList: [],
      invoiceTypeEnum: Enum.invoiceTypeEnum,
      invoiceType: Enum.invoiceTypeEnum.MONTHLY,
      invoiceActionSendEmailAndNotification: Enum.invoiceActionSendEmailAndNotification,
      isActionType: Enum.invoiceActionSendEmailAndNotification.SEND_EMAIL,
      isLoading: false,
      sendInvoiceType: Enum.sendInvoiceTypeEnum.PERIODIC,
      sendInvoiceTypeEnum: Enum.sendInvoiceTypeEnum,
      invoiceSearchData: {
        invoiceNumber: null,
        apartmentCode: null,
        ownerApartment: null,
        apartmentGroupIdFilter: [],
        dateCreatedInvoiceFrom: null,
        dateCreatedInvoiceTo: null,
        invoiceStatus: null
      }
    };
  },
  computed: {
    ...mapGetters([
      'GET_SNACK_BAR'
    ])
  },
  methods: {
    onShowModal: function(invoiceType, isActionType, invoiceArrayList, sendInvoiceType, searchData) {
      this.isActionType = isActionType
      this.invoiceType = invoiceType
      this.invoiceArrayList = invoiceArrayList
      this.sendInvoiceType = sendInvoiceType
      // 
      // update filter invoice
      if (searchData !== null) {
        // let accountingPeriod = searchData && searchData.accountingPeriod
        // this.datePickerValue = utils.formatSqlDate(accountingPeriod, "YYYYMM", "YYYY/MM")
        this.invoiceSearchData.invoiceNumber = searchData && searchData.invoiceNumber
        this.invoiceSearchData.apartmentCode = searchData && searchData.apartmentCode
        this.invoiceSearchData.ownerApartment = searchData && searchData.ownerApartment
        this.invoiceSearchData.apartmentGroupIdFilter = searchData && searchData.apartmentGroupIdFilter
        this.invoiceSearchData.dateCreatedInvoiceFrom = searchData && searchData.dateCreatedInvoiceFrom
        this.invoiceSearchData.dateCreatedInvoiceTo = searchData && searchData.dateCreatedInvoiceTo
        this.invoiceSearchData.invoiceStatus = searchData && searchData.invoiceStatus
      } else {
        this.periodSelect = null
        this.datePickerValue = null
      }
      this.modalTitle = 
        isActionType === this.invoiceActionSendEmailAndNotification.SEND_EMAIL 
        ? "invoice.sendEmailInvoice" : "invoice.sendNotificationInvoice"
      $(this.$refs[`modal-send-email-and-notification`]).modal("show");
    },
    validateDataSendNotification: function() {
      let validateResult = 'OK'
      if (utils.isEmptyString(this.datePickerValue) && this.isSelectMonth) {
        validateResult = this.$t('invoice.by_month')
      } else if (this.invoiceArrayList.length === 0 && !this.isSelectMonth) {
        validateResult = this.$t('invoice.pleaseSelectInvoice')
      }
      return validateResult
    },
    onHandleChangeMonth: function(datePicker) {
      this.periodDataList.forEach(el => {
        // let getTimePeriod = el.date_from.replace("-", "/").slice("-", 7);
        if (el.date_from == datePicker) {
          this.periodSelect = el.value;
        }
      });
    },
    onSendNotification: function() {
      let results = this.validateDataSendNotification()
      if (results === 'OK') {
        let data = {
          isActionType: this.isActionType,
          invoiceType: this.invoiceType,
          invoiceArrayList: !this.isSelectMonth ? this.invoiceArrayList: [],
          periodSelect: this.isSelectMonth ? this.periodSelect : null,
          datePickerValue: this.isSelectMonth ? utils.formatSqlDate(this.datePickerValue, "YYYY/MM", "YYYYMM") : null,
          sendInvoiceType: this.sendInvoiceType,
          lastPaymentDate:this.reminderDatePickerValue,
          // update filter invoice
          invoiceNumber: this.invoiceSearchData.invoiceNumber,
          apartmentCode: this.invoiceSearchData.apartmentCode,
          ownerApartment: this.invoiceSearchData.ownerApartment,
          apartmentGroupIdFilter: this.invoiceSearchData.apartmentGroupIdFilter,
          dateCreatedInvoiceFrom: this.invoiceSearchData.dateCreatedInvoiceFrom,
          dateCreatedInvoiceTo: this.invoiceSearchData.dateCreatedInvoiceTo,
          invoiceStatus: this.invoiceSearchData.invoiceStatus
        }
        this.isLoading = true
        this.SEND_EMAIL_OR_NOTIFICATION_INVOICE(data)
        .then(
          function() {
            this.isLoading = false
            this.SUCCESS_TOAST();
            $(this.$refs[`modal-send-email-and-notification`]).modal("hide");
            this.$emit('callbackInvoiceList', true)
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false
            this.ERROR_TOAST();
          }.bind(this)
        );
      } else {
        this.showError(results)
      }
    },
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    sendInvoiceEmailToUser: function(invoiceType, isActionType, invoiceArrayList) {
      this.isActionType = isActionType
      this.invoiceType = invoiceType
      this.invoiceArrayList = invoiceArrayList
      this.isSelectMonth = false
      this.onSendNotification()
    },
    ...mapActions([
      'ON_SHOW_TOAST',
      'SUCCESS_TOAST',
      'ERROR_TOAST',
      'SEND_EMAIL_OR_NOTIFICATION_INVOICE'
    ])
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Invoice/SendEmailAndNotificationInvoice.vue